import { render } from "./purchase-payment.vue?vue&type=template&id=2dd3191e"
import script from "./purchase-payment.vue?vue&type=script&lang=js"
export * from "./purchase-payment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__